import { EmptyPage } from 'iconoir-react';
import { FunctionComponent } from 'react';

import { IconPropsInterface } from './Icon.types';

const FileIcon: FunctionComponent<IconPropsInterface> = ({
  color = 'black',
  size = '24px',
  ...rest
}) => <EmptyPage width={size} height={size} color={color} {...rest} />;

FileIcon.displayName = 'FileIcon';

export default FileIcon;
